import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useTenant } from '../hooks';

const AccountSettingsContext = createContext();

export const AccountSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { user } = useTenant();

  const loadSettings = async () => {
    if (!user?.tenant_id) return;
    
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No token found');
      }

      const response = await axios.get(
        `${process.env.REACT_APP_Auth_API_BASE_URL}/settings/account`,
        {
          headers: { Authorization: `Bearer ${token}` },
          validateStatus: () => true
        }
      );

      if (response?.data?.data) {
        console.log("AccountSettingsContext - Settings loaded:", response.data.data);
        setSettings(response.data.data);
      } else if (response?.data?.status === 0) {
        console.error("AccountSettingsContext - Error loading settings:", response.data);
        setError(response.data.message || 'Failed to load settings');
      }
    } catch (err) {
      console.error("AccountSettingsContext - Exception:", err);
      setError(err.message || 'Failed to load settings');
    } finally {
      setLoading(false);
    }
  };

  const getChartAccountLevelLimit = () => {
    console.log("AccountSettingsContext - getChartAccountLevelLimit:", settings?.chart_account_level_limit);
    return settings?.chart_account_level_limit ? parseInt(settings.chart_account_level_limit) : null;
  };

  const getCostCenterLevelLimit = () => {
    console.log("AccountSettingsContext - getCostCenterLevelLimit:", settings?.cost_center_level_limit);
    return settings?.cost_center_level_limit ? parseInt(settings.cost_center_level_limit) : null;
  };

  useEffect(() => {
    loadSettings();
  }, [user?.tenant_id]);

  return (
    <AccountSettingsContext.Provider
      value={{
        settings,
        loading,
        error,
        loadSettings,
        getChartAccountLevelLimit,
        getCostCenterLevelLimit
      }}
    >
      {children}
    </AccountSettingsContext.Provider>
  );
};

export const useAccountSettings = () => {
  const context = useContext(AccountSettingsContext);
  if (!context) {
    throw new Error('useAccountSettings must be used within AccountSettingsProvider');
  }
  return context;
};

export default AccountSettingsContext;